import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { tuiGetNativeFocused } from '@taiga-ui/cdk/utils/focus';
import { merge, fromEvent, filter } from 'rxjs';
let TuiKeyboardService = /*#__PURE__*/(() => {
  class TuiKeyboardService {
    constructor() {
      this.doc = inject(DOCUMENT);
      this.sub = merge(fromEvent(this.doc, 'focusout'), fromEvent(this.doc, 'mousedown').pipe(filter(e => Object.is(e.target, this.element)))).subscribe(() => {
        this.show();
      });
      this.inputMode = '';
    }
    ngOnDestroy() {
      this.sub.unsubscribe();
      this.show();
    }
    toggle() {
      if (this.element) {
        this.show();
      } else {
        this.hide();
      }
    }
    hide() {
      const focused = tuiGetNativeFocused(this.doc);
      if (focused?.inputMode === undefined || this.element) {
        return;
      }
      this.element = focused;
      this.inputMode = focused.inputMode;
      focused.inputMode = 'none';
    }
    show() {
      if (!this.element) {
        return;
      }
      this.element.inputMode = 'none';
      this.element.inputMode = this.inputMode;
      this.element = undefined;
    }
    static {
      this.ɵfac = function TuiKeyboardService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiKeyboardService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TuiKeyboardService,
        factory: TuiKeyboardService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TuiKeyboardService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiKeyboardService };
